import { Component, Input, OnInit } from '@angular/core';
import { StateService } from 'src/app/services/state/state.service';
import { TranslateService } from '@ngx-translate/core';
import { SafeStylePipe } from '../../pipes/sanitizer/safe-style.pipe';
import { SafeHtml } from '@angular/platform-browser';
import { ApplicationSettingsService } from '../../services/application-settings/application-settings.service';

@Component({
    selector: 'otb-back-button',
    templateUrl: './back-button.component.html',
    styleUrl: './back-button.component.scss',
    standalone: false,
})
export class BackButtonComponent implements OnInit {
    @Input() text: string = 'dynamische_frontend_texte.shared.button.back';

    translatedText: SafeHtml = '';
    isServiceOnly: boolean = false;

    constructor(
        private translate: TranslateService,
        private stateService: StateService,
        private safeStylePipe: SafeStylePipe,
        private applicationSettingsService: ApplicationSettingsService,
    ) {
        this.isServiceOnly = this.applicationSettingsService.serviceOnly;
    }

    ngOnInit(): void {
        this.translate.get(this.text).subscribe((res: string) => {
            this.translatedText = this.safeStylePipe.transform(res);
        });
    }

    back(): void {
        this.isServiceOnly ? this.stateService.backToServiceOnly() : this.stateService.back();
    }
}
